import { Template } from 'shared/components/presentational/Form/types';

export const isV2Template = (template?: Template): boolean => template === 'V2';
